import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
      userPoolClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
    },
  },
});
